<ng-container *ngIf="pasteOnly; else richEditor">
    <div class="signature-paste">
        <div #pasteTarget class="signature-paste__empty" *ngIf="pasteOnlyEmpty" tabindex="0" role="region"
            [attr.aria-label]="ariaLabel" (paste)="onPaste($event)">
            <span class="signature-paste__icon" aria-hidden="true">
                <lucide-icon name="clipboard-paste" [size]="22" [strokeWidth]="1.8"></lucide-icon>
            </span>
            <strong>1. Copy your signature in Outlook</strong>
            <span>2. Click the button below or press Ctrl+V</span>
            <button type="button" class="signature-paste__button" (click)="pasteFromClipboard()"
                [disabled]="pasteOnlyBusy">
                <lucide-icon name="clipboard-paste" [size]="15" [strokeWidth]="2"></lucide-icon>
                <span *ngIf="pasteOnlyIdle">Paste signature</span>
                <span *ngIf="pasteOnlyBusy">Pasting…</span>
            </button>
            <p class="signature-paste__error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
        </div>

        <ng-container *ngIf="pasteOnlyHasContent">
            <div class="signature-paste__status">
                <span>
                    <lucide-icon name="circle-check" [size]="16" [strokeWidth]="2"></lucide-icon>
                    Signature pasted
                </span>
                <button type="button" (click)="clearPastedSignature()">Clear</button>
            </div>
            <div class="signature-paste__preview">
                <vf-email-signature-preview [html]="pasteOnlyHtml" label="Pasted signature">
                </vf-email-signature-preview>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-template #richEditor>
    <div class="signature-editor">
        <div class="signature-editor__toolbar" role="toolbar" aria-label="Signature formatting">
            <button type="button" class="signature-editor__tool" aria-label="Bold"
                (mousedown)="onFormatMouseDown($event, 'bold')">
                <lucide-icon name="bold" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <button type="button" class="signature-editor__tool" aria-label="Italic"
                (mousedown)="onFormatMouseDown($event, 'italic')">
                <lucide-icon name="italic" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <button type="button" class="signature-editor__tool" aria-label="Underline"
                (mousedown)="onFormatMouseDown($event, 'underline')">
                <lucide-icon name="underline" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <span class="signature-editor__separator" aria-hidden="true"></span>
            <button type="button" class="signature-editor__tool" aria-label="Align left"
                (mousedown)="onFormatMouseDown($event, 'justifyLeft')">
                <lucide-icon name="align-left" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <button type="button" class="signature-editor__tool" aria-label="Align center"
                (mousedown)="onFormatMouseDown($event, 'justifyCenter')">
                <lucide-icon name="align-center" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <button type="button" class="signature-editor__tool" aria-label="Align right"
                (mousedown)="onFormatMouseDown($event, 'justifyRight')">
                <lucide-icon name="align-right" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <span class="signature-editor__separator" aria-hidden="true"></span>
            <button type="button" class="signature-editor__tool" aria-label="Add link"
                (mousedown)="onLinkMouseDown($event)">
                <lucide-icon name="link" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <button type="button" class="signature-editor__tool" aria-label="Add image"
                (mousedown)="onImageMouseDown($event)">
                <lucide-icon name="image" [size]="15" [strokeWidth]="2"></lucide-icon>
            </button>
            <input #imageInput class="signature-editor__file-input" type="file"
                accept="image/png,image/jpeg,image/gif,image/webp" (change)="onImageSelected($event)">
        </div>
        <div #editor class="signature-editor__surface" contenteditable="true" role="textbox"
            aria-multiline="true" [attr.aria-label]="ariaLabel" (input)="onInput()" (paste)="onPaste($event)"></div>
        <p class="signature-editor__error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>
</ng-template>
